import ClientRoleSymbol from './ClientRoleSymbol';

export default ClientRoleSymbol;